import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { dashboardFor } from "@/lib/roleRoute";

// Strict role guard. `allow` is an exact whitelist of role strings.
// If the current user's role is not in the whitelist, send them to THEIR
// own dashboard (per the role map). No fallback to "/" — strict only.
export default function RequireRole({ allow }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-slate-500" data-testid="role-loading">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;

  // Multi-role aware: allow if ANY of the user's roles is whitelisted, not just
  // the single (highest-priority) primary role. Otherwise a doctor who also holds
  // reception (primary role -> reception) gets bounced from doctor-only pages.
  const roles = Array.isArray(user.roles) && user.roles.length ? user.roles : [user.role];
  const allowed = Array.isArray(allow) && roles.some((r) => allow.indexOf(r) !== -1);
  if (!allowed) {
    // Must be clinic-aware, not just role-aware: bouncing a dentist to
    // /doctor/dashboard would ping-pong against RootRedirect sending them
    // straight back to /dental.
    const dest = dashboardFor({ role: user.role, clinicType: user.clinic_type });
    return <Navigate to={dest || "/login"} replace />;
  }
  return <Outlet />;
}
